export default __webpack_public_path__ + "static/media/bnp-paribas.c1767528.png";